<template>
   <v-container fluid>
        <div v-if="!loading">
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Frinchises
            </v-row>
            <v-divider />
            <!--franchises tab-->
            <div v-if="franchises.length">
                <div class="secondary--text my-4 text-left">
                    Franchise stores
                </div>
                <!--table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col class="tabCell text-left">Franchise name</v-col>
                    <v-col v-for="item in headers"
                        class="tabCell text-center"
                        :key="item">{{ item }}
                    </v-col>
                </v-row>
                <div v-for="franchise in franchises" :key="franchise.id">
                    <v-row no-gutters>
                        <v-col class="text-left tabCell">{{ franchise.name }}</v-col>
                            <v-col class="text-center tabCell">{{ channelTrademarks(franchise) }}</v-col>
                            <v-col class="text-center tabCell">{{ franchise.stores }}</v-col>
                            <v-col class="text-center tabCell">{{ formatNumber(franchise.peak_market_coverage) }}</v-col>
                            <v-col class="text-center tabCell">{{ formatNumber(franchise.sales_last) }}</v-col>
                            <v-col class="text-center tabCell">{{ formatNumber(franchise.franchise_cost) }}</v-col>
                            <v-col class="text-center tabCell">{{ formatNumber(franchise.franchise_fee) }}</v-col>
                    </v-row>
                </div>
            </div>
            <v-row v-else class="mt-4"
                justify="center">
                there are no franchises yet &#128580;
            </v-row>
            
            <!--independents tab-->
            <div v-if="independent_chains.length" >
                 <div class="secondary--text my-4 text-left">
                    Registration in the independent chains
                </div>
                <!--table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col class="tabCell text-left">Channel name</v-col>
                    <v-col v-for="item in headers2"
                        class="tabCell text-center"
                        :key="item">{{ item }}
                    </v-col>
                </v-row>
                <div v-for="chan in independent_chains" :key="chan.id">
                    <v-row no-gutters>
                        <v-col class="text-left tabCell">{{ chan.name }}</v-col>
                            <v-col class="text-center tabCell">{{ channelTrademarks(chan) }}</v-col>
                            <v-col class="text-center tabCell">{{ chan.stores }}</v-col>
                            <v-col class="text-center tabCell">{{ formatNumber(chan.peak_market_coverage) }}</v-col>
                            <v-col class="text-center tabCell">{{ formatNumber(chan.sales_last) }}</v-col>
                            <v-col class="text-center tabCell">{{ formatNumber(chan.investment_costs) }}</v-col>
                            <v-col class="text-center tabCell">{{ formatNumber(chan.operational_costs) }}</v-col>
                    </v-row>
                </div>
            </div>    
        </div> 
        <!--loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import Loader from '../../../layouts/Loader.vue';
import { localeNumber } from '../../../functions/common';
export default {
   data() {
        return {
            headers: [
                'Trademarks',
                'Stores',
                'Peak market coverage',
                'Sales in units (last year)',
                'Franchise cost',
                'Franchise fee'
            ],
            headers2: [
                'Trademarks',
                'Stores',
                'Peak market coverage',
                'Sales in units (last year)',
                'Investment costs',
                'Operational cost'
            ],
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        channels() {
            /* console.log(this.$store.getters.channels_all) */
            return this.$store.getters.channels_all;
        },
        franchises() {
            let result = [];
            
            if (this.channels?.length > 0) {
                result = this.channels.filter((chan) => chan.type === 4);
            }
            //console.log(result)
            return result;
        },
        independent_chains() {
            let result = [];

            if (this.channels?.length > 0) {
                result = this.channels.filter((chan) => chan.type === 8);
            }
            //console.log(result)
            return result;
        },
    },
    methods: {
        formatNumber(number) {
            return localeNumber(number, this.locale)
        },    
        channelTrademarks(channel) {
            const res = channel.trademarks.map(tr => tr.name)
            return res.join(', ');
        },
    },
    components: { Loader },

}
</script>
